import * as React from 'react'
import { CreateProduct } from '../ProductStore'
import { ICompany } from '@getgreenline/homi-shared'
import { Collapse } from 'reactstrap'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { observer, inject } from 'mobx-react'
import { HelpLinks } from '../../../../../constants/ExternalLinks'

interface Props {
  product: CreateProduct
  company: ICompany
  warningIcon?: string
  questionIcon?: string
  infoIcon?: string
  isEditMode: boolean
  toggleBtnStyle: (isSelected: boolean) => string
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  isBatchTrackedDisabled: boolean
  isBatchTrackedConfirmationShown: boolean
}

@inject('currentCompanyStore')
@observer
export class InventoryTrackingButtonGroup extends React.Component<Props, State> {
  currentCompanyStore = this.props.currentCompanyStore!
  constructor(props: Props) {
    super(props)

    this.state = {
      isBatchTrackedDisabled: !this.props.product.isBatchTracked || false,
      isBatchTrackedConfirmationShown: this.props.product.isBatchTracked || false,
    }
  }

  componentDidMount = () => {
    /*
      Users can toggle lot-tracking until the product is saved.
      Once the product is saved and lot-tracking is enabled, the lot-tracking feature is no longer available.
    */
    const { isEditMode, product } = this.props
    if (isEditMode && product.isBatchTracked) {
      this.setState({ isBatchTrackedDisabled: true })
    }
  }

  onBatchTrack = (isBatchTracked: boolean) => {
    const { product } = this.props
    product.setIsBatchTracked(isBatchTracked)
    this.setState({
      isBatchTrackedConfirmationShown: isBatchTracked,
    })
  }

  render() {
    const { product, company, toggleBtnStyle } = this.props

    return (
      <>
        <div className='form-group row card__body__text align-items-center'>
          <div className='col-lg-4'>
            <label>Inventory tracking</label>
            <div className='text-muted mb-2'>
              You must track inventory for all cannabis products
            </div>
          </div>
          <div className='col-lg-8'>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {product.isMasterProduct ? (
                <>
                  {company.allowBulk && (
                    <button
                      className={`${toggleBtnStyle(product.inventoryMode === 'bulk')}`}
                      disabled={!!product.pricingGroupId}
                      onClick={() => {
                        if (!product.pricingGroupId) {
                          product.setInventoryMode('bulk')
                          product.setIsBatchTracked(false)
                        }
                      }}
                      style={{ marginRight: '.5rem' }}
                    >
                      Track bulk
                    </button>
                  )}

                  <button
                    className={`${toggleBtnStyle(product.inventoryMode === 'prepack')}`}
                    disabled={!!product.pricingGroupId || product.isDeleted}
                    onClick={() => {
                      if (!product.pricingGroupId) {
                        product.setInventoryMode('prepack')
                      }
                    }}
                    style={{ marginRight: '.5rem' }}
                  >
                    Track
                  </button>
                </>
              ) : (
                <>
                  <button
                    className={`${toggleBtnStyle(product.inventoryMode === true)}`}
                    style={{ marginRight: '.5rem' }}
                    disabled={!!product.pricingGroupId || product.isDeleted}
                    onClick={() => product.setInventoryMode(true)}
                  >
                    Track
                  </button>
                </>
              )}

              <button
                className={`${toggleBtnStyle(product.inventoryMode === false)}`}
                disabled={!!product.pricingGroupId || product.isDeleted}
                onClick={() => {
                  if (!product.pricingGroupId) {
                    product.setInventoryMode(false)
                    product.setIsBatchTracked(false)
                  }
                }}
              >
                Don't track
              </button>
            </div>
          </div>
        </div>
        {product.inventoryMode && product.inventoryMode !== 'bulk' && company.isBatchTracking && (
          <div className='form-group row card__body__text '>
            <div className='col-lg-4'>
              <label>Lot tracking</label>
              <div className='text-muted mb-2'>
                Click{' '}
                <a href={HelpLinks.LOT_TRACKING} target='_blank' rel='noreferrer'>
                  {' '}
                  here
                </a>{' '}
                for more information
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='mt-2'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <button
                    className={`${toggleBtnStyle(product.isBatchTracked)}`}
                    disabled={product.isDeleted}
                    onClick={() => this.onBatchTrack(true)}
                    style={{ marginRight: '.25rem' }}
                  >
                    Enabled
                  </button>
                  <button
                    className={`${toggleBtnStyle(!product.isBatchTracked)}`}
                    disabled={product.isDeleted}
                    onClick={() => this.onBatchTrack(false)}
                    style={{ marginLeft: '.25rem' }}
                  >
                    Disabled
                  </button>
                </div>

                <Collapse isOpen={this.props.product.isBatchTracked}>
                  <div className='mt-3 pb-1' style={{ fontSize: '12px' }}>
                    <label htmlFor='confirmation-list'>Once the product becomes lot-tracked</label>
                    <ul id='confirmation-list' className='pl-3' style={{ paddingLeft: '17px' }}>
                      <li>
                        You may <b>not</b> disable lot-tracking
                      </li>
                      <li>
                        Lot numbers must be included in your audit, purchase order, and sales of
                        this product
                      </li>
                      <li>
                        <b className='text-danger'>
                          To enable barcode-scanning for lots, it is strongly recommended that you
                          audit this product as soon as possible
                        </b>
                      </li>
                    </ul>
                    <p>
                      Click{' '}
                      <a href={HelpLinks.LOT_TRACKING} target='_blank' rel='noreferrer'>
                        here
                      </a>{' '}
                      for more information.
                    </p>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}
